import Make from "../home/make";
import { Link } from "react-router-dom";
import forward from "../../asserts/images/forward.svg";
import "./gallery.scss";
import Items from "./gallery_photos";

const Gallery = () => {
  return (
    <div className="row">
      <div className="gallery-box">
        <p className="path">
          <Link to="/home">Home</Link> <img src={forward} className="pb-1" />
          Gallery
        </p>
        <h1 className="col-lg-8 col-md-12 gallery-heading">
          Moments of Kindness – Our Impact in Pictures.
        </h1>
      </div>
      <Items></Items>
      <Make></Make>
    </div>
  );
};
export default Gallery;
